"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  '/': {
    title: 'Main page',
    view: 'Home',
    "public": true,
    locales: {
      az: '/az',
      en: '/en',
      ru: '/ru'
    }
  },
  '/az': {
    ref: '/',
    lang: 'az',
    title: 'Baş səhifə'
  },
  '/en': {
    ref: '/',
    lang: 'en',
    title: 'Main page'
  },
  '/ru': {
    ref: '/',
    lang: 'ru',
    title: 'Главная страница'
  },
  '/notfound': {
    title: '404',
    view: 'NotFound',
    "public": true,
    locales: {
      az: '/az/notfound',
      en: '/en/notfound',
      ru: '/ru/notfound'
    }
  },
  '/az/notfound': {
    ref: '/notfound',
    lang: 'az',
    title: 'Səhifə tapılmadı'
  },
  '/en/notfound': {
    ref: '/notfound',
    lang: 'en',
    title: 'Page not found'
  },
  '/ru/notfound': {
    ref: '/notfound',
    lang: 'ru',
    title: 'Страница не найдена'
  },
  '/error': {
    title: 'Error page',
    view: 'Error',
    layout: 'Error',
    "public": true,
    locales: {}
  },
  '/soon': {
    title: 'Coming Soon',
    view: 'Soon',
    layout: 'Soon',
    "public": true,
    locales: {}
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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